import ReactGA from 'react-ga4';

export const trackPage = (page, options = {}) => {
  ReactGA.send({ hitType: 'pageview', page, ...options });
};
